import {OrderAttachmentSummaryValidationModel, OrderPreviewModelStateType} from "../../order.models";
import {BasePopupProps} from "../../../../utils/Models";
import {useTranslation} from "react-i18next";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "../../../../components/controls/FlintButton";
import {useOrderPreviewContext} from "../OrderPreviewContext";
import {bool} from "yup";

export default function MissingAttachmentsComponent(props: MissingAttachmentsComponentProps) {
    const {t} = useTranslation();
    return (
        <div className={"text-center"}>
            <div className="alert alert-info"
                 dangerouslySetInnerHTML={{__html: t("ORDER_PREVIEW_MissingAttachmentsAlertText")}}></div>
            <div className="row text-bold text-uppercase align-items-center gy-3 mb-3">
                <div className="col-2">
                    <div className={"font-size-larger"}>PDF</div>
                </div>
                <div className="col-5">
                    <div
                        className={props.model.PdfRequested ? "bg-success color-light py-1" : "bg-success-light color-success py-1"}>
                        {props.model.PdfRequested ? t("ORDER_PREVIEW_MissingAttachments_Requested") : t("ORDER_PREVIEW_MissingAttachments_NotRequested")}
                    </div>
                </div>
                <div className="col-5">
                    <div className={props.model.PdfMissing ? "bg-error color-light py-1" : "bg-error-light color-error py-1"}>
                        {props.model.PdfUploaded ? t("ORDER_PREVIEW_MissingAttachments_Uploaded") : t("ORDER_PREVIEW_MissingAttachments_NotUploaded")}
                    </div>
                </div>

                <div className="col-2">
                    <div className={"font-size-larger"}>CXF</div>
                </div>
                <div className="col-5">
                    <div
                        className={props.model.CxFRequested ? "bg-success color-light py-1" : "bg-success-light color-success py-1"}>
                        {props.model.CxFRequested ? t("ORDER_PREVIEW_MissingAttachments_Requested") : t("ORDER_PREVIEW_MissingAttachments_NotRequested")}
                    </div>
                </div>
                <div className="col-5">
                    <div className={props.model.CxFMissing ? "bg-error color-light py-1" : "bg-error-light color-error py-1"}>
                        {props.model.CxFUploaded ? t("ORDER_PREVIEW_MissingAttachments_Uploaded") : t("ORDER_PREVIEW_MissingAttachments_NotUploaded")}
                    </div>
                </div>
                <div className="col-2">
                    <div className={"font-size-larger"}>XLS</div>
                </div>
                <div className="col-5">
                    <div
                        className={props.model.XlsRequested ? "bg-success color-light py-1" : "bg-success-light color-success py-1"}>
                        {props.model.XlsRequested ? t("ORDER_PREVIEW_MissingAttachments_Requested") : t("ORDER_PREVIEW_MissingAttachments_NotRequested")}
                    </div>
                </div>
                <div className="col-5">
                    <div className={props.model.XlsMissing ? "bg-error color-light py-1" : "bg-error-light color-error py-1"}>
                        {props.model.XlsUploaded ? t("ORDER_PREVIEW_MissingAttachments_Uploaded") : t("ORDER_PREVIEW_MissingAttachments_NotUploaded")}
                    </div>
                </div>
            </div>
            <WindowActionsBar layout={"center"}>
                <FlintButton disabled={props.isLoading} themeColor={"secondary"}
                             onClick={props.OnCancelled}>{t("Cancel")}</FlintButton>
                <FlintButton disabled={props.isLoading} themeColor={"primary"}
                             onClick={()=>props.OnConfirmedAndSaved()}>{t("COMMON_COMPLETE_ANYWAY")}</FlintButton>
            </WindowActionsBar>
        </div>
    )
}

export interface MissingAttachmentsComponentProps extends BasePopupProps {
    isLoading : boolean;
    model: OrderAttachmentSummaryValidationModel;
}